<template>
  <div class='product-detail-popup-inner'>
    <div class='product-detail-popup-top clearfix'>
      <div class='product-detail-popup-top-lft'>
        <product-image-swiper
            :productImageList='productDetailPopupInfo.productImageList'
            :productMicroImageList='productDetailPopupInfo.productMicroImageList'
            :imageSwiperBig='imageSwiperBig'
        >
        </product-image-swiper>
      </div>
      <div class='product-detail-popup-top-rgt'>
        <div class='product-name'>{{productDetailPopupInfo.productName}}</div>
        <div>Item# {{productDetailPopupInfo.productID}}</div>
        <div>Imprint Options: {{productDetailPopupInfo.imprintOptions}}</div>
        <div>Minimum Quantity: {{productDetailPopupInfo.minQuantity}}</div>
        <div>Production Time: {{productDetailPopupInfo.productionTime}}</div>
        <div class='product-tips'><span color='#FF0000'>* </span>excludes weekends &amp; holidays</div>
      </div>
    </div>
    <div class='product-detail-popup-desc'>
        <div v-html='productDetailPopupInfo.productPureDesc'></div>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent, type PropType } from 'vue'
import { type ProductDetailPopupInfo } from '@anypromo/shared/types/Product'
import ProductImageSwiper from './ProductImageSwiper.vue'

import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.min.css'

export default defineComponent({
  name: 'ProductDetail',
  components: { ProductImageSwiper },
  props: {
    productDetailPopupInfo: { type: Object as PropType<ProductDetailPopupInfo>, default: {} as ProductDetailPopupInfo },
    imageSwiperBig: { type: Object as PropType<Swiper>, default: {} as Swiper }
  }
})
</script>

<style scoped>

.product-detail-popup-inner {
    width: 780px;
    height: auto;
}

.product-detail-popup-inner {
    width: 780px;
    height: auto;
    padding: 7px;
}

.product-detail-popup-top {
    border-bottom: 1px solid #d7d7d7;
    padding-bottom: 15px;
}

.product-detail-popup-desc {
    line-height: 2;
    font-size: 14px;
    padding: 20px 0;
    height: 360px;
    overflow-y: auto;
    min-height:100px;
    text-align: left;
}

.product-detail-popup-desc :deep(ul)  {
    padding: 0 0 0 15px;
    margin:0;
    list-style-type: initial;
}

.product-detail-popup-desc :deep(li) {
    list-style: initial;
}

.product-detail-popup :deep(.onsale-content) {
    border: 0;
    padding: 0;
    margin: 0;
}

.product-detail-popup-top-lft {
    width: 208px;
    float: left;
}

.product-detail-popup-top-rgt {
    font-size: 14px;
    color: #4b4a4a;
    line-height: 2;
    text-align: left;
}

.product-detail-popup-top-rgt :deep(.product-name) {
    font-size: 18px;
    font-weight: 600;
    line-height: 1.5;
    margin-bottom: 20px;
}

.product-detail-popup-top-rgt :deep(.product-tips) {
    font-size: 12px;
    color: #448ccb;
}

.product-detail-popup-desc :deep(.RecentlyImg) {
    margin: 0 auto;
}

.product-detail-popup-desc :deep(.r-name) {
    padding: 0 10px;
    margin-top: 10px;
    height: 52px;
    overflow: hidden;
}

.product-detail-popup-desc :deep(.a_glossary) {
    color: #555;
    text-decoration: none;
    cursor:text;
}

.product-detail-popup-desc :deep(.div_thumb) {
    display: none;
}

/* .product-detail-popup-desc :deep(.a_glossary:hover) {
    text-decoration:underline;
} */

@media(min-width:550px) {
    .product-detail-popup-top {
        display: flex;
        width: 100%;
    }
}

.product-detail-popup-top-rgt {
    display: table-cell;
    vertical-align: middle;
    margin: 0;
    float: none;
}

.product-detail-popup-top-rgt {
    padding-left: 40px;
}

@media (min-width: 1200px) {
    .product-detail-popup-desc :deep(.jcarousel-pagination .hidden-lg)  {
        display: block !important;
        bottom: -30px;
    }
}

@media (min-width: 992px) {
    .product-detail-popup-desc :deep(.top100-items-mid) > div {
        left: -100px;
        width: 800px;
    }
}

@media (min-width: 768px) {
    .product-detail-popup-top-rgt {
        padding-top: 30px;
    }
}

@media (max-width: 800px) {
    .product-detail-popup-inner {
        width: 100%;
        padding: 0;
    }
}

@media (max-width: 768px) {
    .td-width3 {
        width: 15%;
        padding-right: 0px;
    }

    .td-width4 {
        padding-left: 0;
    }

    .product-detail-popup-desc {
        max-height: 200px;
    }
}

@media (max-width: 550px) {
    .product-detail-popup-top-lft, .product-detail-popup-top-rgt {
        display: block;
    }

    .product-detail-popup-top-lft {
        float: none;
        margin: 0 auto;
    }

    .product-detail-popup-top-rgt {
        padding-left: 0;
        margin: 10px 0 0 0;
    }
}

.tip-yellow-light {
    z-index: 99999;
}

</style>
